import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from '@mui/material';
import React from 'react';
import { TypographyH4Bold } from './style';
import { McqComponentQuestion } from '../../../shared/shared.interfaces';
import {
  SelectedIcon,
  UnselectedIcon
} from '../../../shared/components/customRadio';

export const MCQComponent = ({
  id,
  title,
  question,
  options,
  handleChange,
  value
}: {
  id: string;
  title: string;
  question: string;
  options: McqComponentQuestion[];
  handleChange: (
    type: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  value: string;
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <TypographyH4Bold
        sx={{ textTransform: 'uppercase', textAlign: 'center', mb: 1 }}
      >
        {title}
      </TypographyH4Bold>

      {/* Subheading or question */}
      <Box sx={{ width: '100%', textAlign: 'left' }} data-testid={id}>
        <Typography
          sx={{
            fontFamily: 'Calibri, sans-serif',
            fontSize: '1rem',
            fontWeight: 400,
            color: '#002A3A',
            mb: 1
          }}
        >
          {question}
        </Typography>

        {/* Radio Group */}
        <RadioGroup value={value} onChange={(e) => handleChange(id, e)}>
          {options.length > 0 &&
            options.map((option: McqComponentQuestion) => (
              <FormControlLabel
                key={option?.value}
                value={option?.value}
                control={
                  <Radio
                    icon={<UnselectedIcon />}
                    checkedIcon={<SelectedIcon />}
                  />
                }
                label={option?.label}
                sx={{
                  // Style the label text
                  '.MuiFormControlLabel-label': {
                    fontFamily: 'Calibri',
                    fontSize: '1rem',
                    fontWeight: 400,
                    color: '#002A3A'
                  },
                  mb: 1 // spacing between options
                }}
              />
            ))}
        </RadioGroup>
      </Box>
    </Box>
  );
};
